module.exports = __webpack_public_path__ + "static/media/logo_placeholder.a04e399f.jpg";